module.exports = __webpack_public_path__ + "img/basket.0527c346.svg";